export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-scale/src/number.js
// module id = ../../../../d3-scale/src/number.js
// module chunks = 3